import React, { useState } from 'react';
import {
    Card,
    CardBody,
    Col,
    Row,
    Dropdown,
    Button,
    UncontrolledDropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    UncontrolledButtonDropdown,
    ButtonDropdown,
    Label,
    Form,
    FormGroup,
    Input,
} from 'reactstrap';

function Dropdowns(props) {
    const [drp_primary1, setDrp_primary1] = useState(false);
    const [drp_secondary1, setDrp_secondary1] = useState(false);
    const [drp_success1, setDrp_success1] = useState(false);
    const [drp_info1, setDrp_info1] = useState(false);
    const [drp_warning1, setDrp_warning1] = useState(false);
    const [drp_danger1, setDrp_danger1] = useState(false);
    const [drp_secondary, setDrp_secondary] = useState(false);
    const [drp_secondary_lg, setDrp_secondary_lg] = useState(false);
    const [drp_secondary_sm, setDrp_secondary_sm] = useState(false);
    const [drp_secondary_sm1, setDrp_secondary_sm1] = useState(false);
    const [drp_dark_sm1, setDrp_dark_sm1] = useState(false);
    const [drp_menu_sm1, setDrp_menu_sm1] = useState(false);
    const [dropup1, setDropup1] = useState(false);
    const [drp_up11, setDrp_up11] = useState(false);
    // const [drop_align, setDrop_align] = useState(false);
    // const [info_dropup1, setInfo_dropup1] = useState(false);
    const [infodrp_up11, setInfodrp_up11] = useState(false);
    const [drop_right, setDropRight] = useState(false);
    const [info_dropup111, setInfo_dropup111] = useState(false);
    const [infodrp_up1111, setInfodrp_up1111] = useState(false);
    const [align_1, setAlign1] = useState(false);
    const [align_2, setAlign2] = useState(false);
    const [align_3, setAlign3] = useState(false);
    const [align_4, setAlign4] = useState(false);
    const [align_5, setAlign5] = useState(false);
    const [align_6, setAlign6] = useState(false);
    const [align_7, setAlign7] = useState(false);
    const [close1, setClose1] = useState(false);
    const [close2, setClose2] = useState(false);
    const [close3, setClose3] = useState(false);
    const [close4, setClose4] = useState(false);
    const [content1, setContent1] = useState(false);
    const [content2, setContent2] = useState(false);
    const [content3, setContent3] = useState(false);



    return (
        <React.Fragment>
            <Col lg={12}>
                <Card id="dropdowns">
                    <CardBody>
                        <h4 className="card-title mb-4">Dropdowns</h4>

                        <Row>
                            <Col lg={6}>
                                <div className="">
                                    <h5 className="font-size-14">Basic</h5>
                                    <p className="card-title-desc">
                                        Any single{" "}
                                        <code className="highlighter-rouge">
                                            .btn
                                        </code>{" "}
                                        can be turned into a dropdown toggle with
                                        some markup changes. Here’s how you can put
                                        them to work with either{" "}
                                        <code className="highlighter-rouge">
                                            &lt;button&gt;
                                        </code>
                                        elements:
                                    </p>

                                    <Row>
                                        <Col sm={6}>
                                            <UncontrolledDropdown>
                                                <DropdownToggle
                                                    className="btn btn-secondary"
                                                    type="button"
                                                >
                                                    Dropdown Button{" "}
                                                    <i className="mdi mdi-chevron-down"></i>
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem>Action</DropdownItem>
                                                    <DropdownItem>
                                                        Another action
                                                    </DropdownItem>
                                                    <DropdownItem>
                                                        Something else here
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </Col>

                                        <Col sm={6}>
                                            <UncontrolledDropdown className="mt-4 mt-sm-0">
                                                <DropdownToggle
                                                    tag="a"
                                                    className="btn btn-secondary"
                                                >
                                                    Dropdown link{" "}
                                                    <i className="mdi mdi-chevron-down"></i>
                                                </DropdownToggle>

                                                <DropdownMenu>
                                                    <DropdownItem>Action</DropdownItem>
                                                    <DropdownItem>
                                                        Another action
                                                    </DropdownItem>
                                                    <DropdownItem>
                                                        Something else here
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mt-4 mt-lg-0">
                                    <h5 className="font-size-14">Variant</h5>
                                    <p className="card-title-desc">
                                        The best part is you can do this with any
                                        button variant, too:
                                    </p>

                                    <div className="d-flex gap-2 flex-wrap">
                                        <UncontrolledButtonDropdown className="btn-group">
                                            <DropdownToggle
                                                color="primary"
                                                type="button"
                                            >
                                                Primary{" "}
                                                <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>
                                                    Another action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Something else here
                                                </DropdownItem>
                                                <div className="dropdown-divider"></div>
                                                <DropdownItem>
                                                    Separated link
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                        <UncontrolledButtonDropdown className="btn-group">
                                            <DropdownToggle
                                                color="secondary"
                                                type="button"
                                            >
                                                Secondary{" "}
                                                <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>
                                                    Another action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Something else here
                                                </DropdownItem>
                                                <div className="dropdown-divider"></div>
                                                <DropdownItem>
                                                    Separated link
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                        <UncontrolledButtonDropdown>
                                            <DropdownToggle
                                                color="success"
                                                type="button"
                                            >
                                                Success{" "}
                                                <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>
                                                    Another action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Something else here
                                                </DropdownItem>
                                                <div className="dropdown-divider"></div>
                                                <DropdownItem>
                                                    Separated link
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                        <UncontrolledButtonDropdown>
                                            <DropdownToggle
                                                color="info"
                                                type="button"
                                            >
                                                Info{" "}
                                                <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>
                                                    Another action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Something else here
                                                </DropdownItem>
                                                <div className="dropdown-divider"></div>
                                                <DropdownItem>
                                                    Separated link
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                        <UncontrolledButtonDropdown>
                                            <DropdownToggle
                                                color="warning"
                                                type="button"
                                            >
                                                Warning{" "}
                                                <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>
                                                    Another action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Something else here
                                                </DropdownItem>
                                                <div className="dropdown-divider"></div>
                                                <DropdownItem>
                                                    Separated link
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                        <UncontrolledButtonDropdown>
                                            <DropdownToggle
                                                color="danger"
                                                type="button"
                                            >
                                                Danger{" "}
                                                <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>
                                                    Another action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Something else here
                                                </DropdownItem>
                                                <div className="dropdown-divider"></div>
                                                <DropdownItem>
                                                    Separated link
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">Split Button</h5>
                                    <p className="card-title-desc">
                                        The best part is you can do this with any
                                        button variant, too:
                                    </p>

                                    <div className="d-flex gap-2 flex-wrap">
                                        <div className="btn-group">
                                            <ButtonDropdown
                                                isOpen={drp_primary1}
                                                toggle={() =>
                                                    setDrp_primary1(!drp_primary1)
                                                }
                                            >
                                                <Button id="caret" color="primary">
                                                    Primary
                                                </Button>
                                                <DropdownToggle
                                                    caret
                                                    color="primary"
                                                    className="dropdown-toggle-split"
                                                >
                                                    <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem header>
                                                        Header
                                                    </DropdownItem>
                                                    <DropdownItem disabled>
                                                        Action
                                                    </DropdownItem>
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                    <DropdownItem divider />
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>{" "}
                                        <div className="btn-group">
                                            <ButtonDropdown
                                                isOpen={drp_secondary1}
                                                toggle={() =>
                                                    setDrp_secondary1(!drp_secondary1)
                                                }
                                            >
                                                <Button id="caret" color="secondary">
                                                    Secondary
                                                </Button>
                                                <DropdownToggle
                                                    caret
                                                    color="secondary"
                                                    className="dropdown-toggle-split"
                                                >
                                                    <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem header>
                                                        Header
                                                    </DropdownItem>
                                                    <DropdownItem disabled>
                                                        Action
                                                    </DropdownItem>
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                    <DropdownItem divider />
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>{" "}
                                        <div className="btn-group">
                                            <ButtonDropdown
                                                isOpen={drp_success1}
                                                toggle={() =>
                                                    setDrp_success1(!drp_success1)
                                                }
                                            >
                                                <Button id="caret" color="success">
                                                    Success
                                                </Button>
                                                <DropdownToggle
                                                    caret
                                                    color="success"
                                                    className="dropdown-toggle-split"
                                                >
                                                    <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem header>
                                                        Header
                                                    </DropdownItem>
                                                    <DropdownItem disabled>
                                                        Action
                                                    </DropdownItem>
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                    <DropdownItem divider />
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>{" "}
                                        <div className="btn-group">
                                            <ButtonDropdown
                                                isOpen={drp_info1}
                                                toggle={() => setDrp_info1(!drp_info1)}
                                            >
                                                <Button id="caret" color="info">
                                                    Info
                                                </Button>
                                                <DropdownToggle
                                                    caret
                                                    color="info"
                                                    className="dropdown-toggle-split"
                                                >
                                                    <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem header>
                                                        Header
                                                    </DropdownItem>
                                                    <DropdownItem disabled>
                                                        Action
                                                    </DropdownItem>
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                    <DropdownItem divider />
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>{" "}
                                        <div className="btn-group">
                                            <ButtonDropdown
                                                isOpen={drp_warning1}
                                                toggle={() =>
                                                    setDrp_warning1(!drp_warning1)
                                                }
                                            >
                                                <Button id="caret" color="warning">
                                                    Warning
                                                </Button>
                                                <DropdownToggle
                                                    caret
                                                    color="warning"
                                                    className="dropdown-toggle-split"
                                                >
                                                    <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem header>
                                                        Header
                                                    </DropdownItem>
                                                    <DropdownItem disabled>
                                                        Action
                                                    </DropdownItem>
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                    <DropdownItem divider />
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>{" "}
                                        <div className="btn-group">
                                            <ButtonDropdown
                                                isOpen={drp_danger1}
                                                toggle={() =>
                                                    setDrp_danger1(!drp_danger1)
                                                }
                                            >
                                                <Button id="caret" color="danger">
                                                    Danger
                                                </Button>
                                                <DropdownToggle
                                                    caret
                                                    color="danger"
                                                    className="dropdown-toggle-split"
                                                >
                                                    <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem header>
                                                        Header
                                                    </DropdownItem>
                                                    <DropdownItem disabled>
                                                        Action
                                                    </DropdownItem>
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                    <DropdownItem divider />
                                                    <DropdownItem>
                                                        Another Action
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>{" "}
                                    </div>
                                </div>
                            </Col>

                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">Sizing</h5>
                                    <p className="card-title-desc">
                                        Button dropdowns work with buttons of all
                                        sizes, including default and split dropdown
                                        buttons.
                                    </p>

                                    <div className="">
                                        <ButtonDropdown
                                            isOpen={drp_secondary}
                                            toggle={() =>
                                                setDrp_secondary(!drp_secondary)
                                            }
                                            className="me-1 mt-2"
                                        >
                                            <DropdownToggle
                                                caret
                                                color="primary"
                                                className="btn btn-primary btn-lg"
                                            >
                                                Large Button{" "}
                                                <i className="mdi mdi-chevron-down" />
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem disabled>
                                                    Action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>{" "}
                                        <ButtonDropdown
                                            isOpen={drp_secondary_lg}
                                            toggle={() =>
                                                setDrp_secondary_lg(!drp_secondary_lg)
                                            }
                                            className="me-1 mt-2"
                                        >
                                            <Button className="btn btn-secondary btn-lg">
                                                Large button
                                            </Button>
                                            <DropdownToggle
                                                caret
                                                color="secondary"
                                                className="btn btn-secondary btn-lg dropdown-toggle-split"
                                            >
                                                <i className="mdi mdi-chevron-down" />
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem disabled>
                                                    Action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>{" "}
                                        <ButtonDropdown
                                            isOpen={drp_secondary_sm}
                                            toggle={() =>
                                                setDrp_secondary_sm(!drp_secondary_sm)
                                            }
                                            className="me-1 mt-2"
                                        >
                                            <DropdownToggle
                                                caret
                                                color="info"
                                                className="btn btn-info btn-sm"
                                            >
                                                Small button{" "}
                                                <i className="mdi mdi-chevron-down" />
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem disabled>
                                                    Action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>{" "}
                                        <ButtonDropdown
                                            isOpen={drp_secondary_sm1}
                                            toggle={() =>
                                                setDrp_secondary_sm1(!drp_secondary_sm1)
                                            }
                                            className="me-1 mt-2"
                                        >
                                            <Button className="btn btn-secondary btn-sm">
                                                {" "}
                                                Small button
                                            </Button>
                                            <DropdownToggle
                                                caret
                                                color="secondary"
                                                className="btn btn-secondary btn-sm dropdown-toggle-split"
                                            >
                                                <i className="mdi mdi-chevron-down" />
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem disabled>
                                                    Action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">Dark Dropdowns</h5>
                                    <p className="card-title-desc">Opt into darker dropdowns to match a dark navbar or custom style by adding <code>.dropdown-menu-dark</code> onto an existing <code>.dropdown-menu</code>. No changes are required to the dropdown items.</p>

                                    <ButtonDropdown isOpen={drp_dark_sm1}
                                        toggle={() =>
                                            setDrp_dark_sm1(!drp_dark_sm1)
                                        }>
                                        <DropdownToggle className="btn btn-secondary" caret>
                                            Dropdown button <i className="mdi mdi-chevron-down"></i>
                                        </DropdownToggle>
                                        <DropdownMenu dark>
                                            <DropdownItem active>Action</DropdownItem>
                                            <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                            <DropdownItem divider />
                                            <DropdownItem>Separated link</DropdownItem>
                                        </DropdownMenu>
                                    </ButtonDropdown>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">Menu Alignment</h5>
                                    <p className="card-title-desc">Add <code className="highlighter-rouge">.dropdown-menu-end</code> to a <code className="highlighter-rouge">.dropdown-menu</code> to right align the dropdown menu.</p>

                                    <ButtonDropdown isOpen={drp_menu_sm1}
                                        toggle={() =>
                                            setDrp_menu_sm1(!drp_menu_sm1)
                                        }>
                                        <DropdownToggle className="btn btn-info" caret>
                                            Right-aligned menu example <i className="mdi mdi-chevron-down"></i>
                                        </DropdownToggle>
                                        <DropdownMenu end={true}>
                                            <DropdownItem>Action</DropdownItem>
                                            <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                        </DropdownMenu>
                                    </ButtonDropdown>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">Menu Alignment Option</h5>
                                    <p className="card-title-desc">Taking most of the options shown above, here’s a small kitchen sink demo of various dropdown alignment options in one place.</p>

                                    <div className="d-flex flex-wrap gap-2 align-items-center">
                                        <ButtonDropdown isOpen={align_1}
                                            toggle={() => setAlign1(!align_1)}>
                                            <DropdownToggle className="btn btn-secondary" caret>
                                                Dropdown <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>

                                        <ButtonDropdown isOpen={align_2}
                                            toggle={() => setAlign2(!align_2)}>
                                            <DropdownToggle className="btn btn-info" caret>
                                                Right-aligned menu <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu end={true}>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>

                                        <ButtonDropdown isOpen={align_3}
                                            toggle={() => setAlign3(!align_3)}>
                                            <DropdownToggle className="btn btn-secondary" caret>
                                                Left-aligned, right-aligned lg <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu className="dropdown-menu-lg-end">
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>

                                        <ButtonDropdown isOpen={align_4}
                                            toggle={() => setAlign4(!align_4)}>
                                            <DropdownToggle className="btn btn-info" caret>
                                                Right-aligned, left-aligned lg <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu className="dropdown-menu-lg-start">
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>

                                        <ButtonDropdown isOpen={align_5}
                                            toggle={() => setAlign5(!align_5)} direction="start">
                                            <DropdownToggle className="btn btn-secondary" caret>
                                                Dropstart <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>

                                        <ButtonDropdown isOpen={align_6}
                                            toggle={() => setAlign6(!align_6)} direction="end">
                                            <DropdownToggle className="btn btn-info" caret>
                                                Dropend <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>

                                        <ButtonDropdown isOpen={align_7} toggle={() => setAlign7(!align_7)} direction="up">
                                            <DropdownToggle className="btn btn-secondary" caret>
                                                Dropup <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">Auto Close Behavior</h5>
                                    <p className="card-title-desc">By default, the dropdown menu is closed when clicking inside or outside the dropdown menu. You can use the <code>autoClose</code> option to change this behavior of the dropdown.</p>
                                    <div className="d-flex flex-wrap gap-3">
                                        <ButtonDropdown isOpen={close1} toggle={() => setClose1(!close1)} >
                                            <DropdownToggle className="btn btn-secondary" caret>
                                                Default dropdown <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>
                                        <ButtonDropdown isOpen={close2} toggle={() => setClose2(!close2)} autoclose="inside">
                                            <DropdownToggle className="btn btn-info" caret>
                                                Clickable outside <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>

                                        <ButtonDropdown isOpen={close3} toggle={() => setClose3(!close3)} autoclose="outside">
                                            <DropdownToggle className="btn btn-secondary" caret>
                                                Clickable inside <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>

                                        <ButtonDropdown isOpen={close4} toggle={() => setClose4(!close4)}>
                                            <DropdownToggle className="btn btn-info" caret>
                                                Manual close <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                                <DropdownItem>Menu item</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">Menu Content</h5>
                                    <p className="card-title-desc">Example of dropdown menu Headers, Text, Forms content</p>

                                    <div className="d-flex flex-wrap gap-2">
                                        {/* Header */}
                                        <ButtonDropdown isOpen={content1} toggle={() => setContent1(!content1)} >
                                            <DropdownToggle color='primary' className="btn btn-primary" caret>
                                                Header <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <div className="dropdown-header noti-title">
                                                    <h5 className="font-size-13 text-muted text-truncate mn-0">Welcome Jessie!</h5>
                                                </div>
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>Another action</DropdownItem>
                                                <DropdownItem>Something else here</DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>Separated link</DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>
                                        
                                        {/* Text */}
                                        <ButtonDropdown isOpen={content2} toggle={() => setContent2(!content2)}>
                                            <DropdownToggle className="btn btn-success" caret>
                                                Text <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu className="dropdown-menu-md p-3">
                                                <p>
                                                    Some example text that's free-flowing within the dropdown menu.
                                                </p>
                                                <p className="mb-0">
                                                    And this is more example text.
                                                </p>
                                            </DropdownMenu>
                                        </ButtonDropdown>

                                        {/* Forms */}
                                        <ButtonDropdown isOpen={content3} toggle={() => setContent3(!content3)}>
                                            <DropdownToggle color='light' className="btn btn-light text-dark" caret>
                                                Forms <i className="mdi mdi-chevron-down"></i>
                                            </DropdownToggle>
                                            <DropdownMenu className="dropdown-menu-md p-4">
                                                <Form>
                                                    <FormGroup className="mb-2">
                                                        <Label for="exampleDropdownFormEmail">Email address</Label>
                                                        <Input type="email" name="email" id="exampleDropdownFormEmail" placeholder="email@example.com" />
                                                    </FormGroup>
                                                    <FormGroup className="mb-2">
                                                        <Label for="exampleDropdownFormPassword">Password</Label>
                                                        <Input type="password" name="password" id="exampleDropdownFormPassword" placeholder="Password" />
                                                    </FormGroup>
                                                    <FormGroup className="mb-2">
                                                        <Input type="checkbox" id="rememberdropdownCheck"  />
                                                        <Label className="form-check-label" for="rememberdropdownCheck">Remember me</Label>
                                                    </FormGroup>
                                                    <button type="submit" className="btn btn-primary">Sign in</button>
                                                </Form>
                                            </DropdownMenu>
                                        </ButtonDropdown>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">
                                        Dropup Variation
                                    </h5>
                                    <p className="card-title-desc">
                                        Trigger dropdown menus above elements by
                                        adding{" "}
                                        <code className="highlighter-rouge">
                                            .dropup
                                        </code>{" "}
                                        to the parent element.
                                    </p>

                                    <div className="d-flex gap-2 flex-wrap">
                                        <Dropdown
                                            isOpen={dropup1}
                                            direction="up"
                                            toggle={() => setDropup1(!dropup1)}
                                        >
                                            <DropdownToggle className="btn btn-secondary dropdown-toggle">
                                                Dropup{" "}
                                                <i className="mdi mdi-chevron-up" />
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>
                                                    Another action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Something else here
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>{" "}
                                        <ButtonDropdown
                                            direction="right"
                                            isOpen={drp_up11}
                                            toggle={() => setDrp_up11(!drp_up11)}
                                        >
                                            <DropdownToggle caret color="secondary">
                                                Menu is right-aligned{" "}
                                                <i className="mdi mdi-chevron-down" />
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem header>
                                                    Header
                                                </DropdownItem>
                                                <DropdownItem disabled>
                                                    Action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                            </DropdownMenu>{" "}
                                        </ButtonDropdown>
                                    </div>
                                </div>
                            </Col>

                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">
                                        Dropright Variation
                                    </h5>
                                    <p className="card-title-desc">
                                        Trigger dropdown menus at the right of the
                                        elements by adding <code>.dropend</code> to
                                        the parent element.
                                    </p>

                                    <div className="d-flex gap-3 flex-wrap">
                                        <Dropdown
                                            isOpen={drop_right}
                                            direction="right"
                                            className="btn-group dropend"
                                            toggle={() => setDropRight(!drop_right)}
                                        >
                                            <DropdownToggle
                                                className="btn btn-info"
                                                caret
                                            >
                                                Dropright{" "}
                                                <i className="mdi mdi-chevron-right" />
                                            </DropdownToggle>
                                            <DropdownMenu data-popper-placement="right-start">
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>
                                                    Another action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Something else here
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>
                                        <ButtonDropdown
                                            direction="right"
                                            isOpen={infodrp_up11}
                                            className="btn-group dropend"
                                            toggle={() =>
                                                setInfodrp_up11(!infodrp_up11)
                                            }
                                        >
                                            <Button id="caret" color="info">
                                                Split Dropend
                                            </Button>
                                            <DropdownToggle
                                                caret
                                                color="info"
                                                className="dropdown-toggle-split"
                                            >
                                                <i className="mdi mdi-chevron-right" />
                                            </DropdownToggle>
                                            <DropdownMenu data-popper-placement="right-start">
                                                <DropdownItem>Action</DropdownItem>
                                                <DropdownItem>
                                                    Another action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Something else here
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-3">
                            

                            <Col lg={6}>
                                <div className="mt-4">
                                    <h5 className="font-size-14">
                                        Dropleft Variation
                                    </h5>
                                    <p className="card-title-desc">
                                        Trigger dropdown menus at the left of the
                                        elements by adding <code>.dropend</code> to
                                        the parent element.
                                    </p>

                                    <div className="d-flex gap-2 flex-wrap">
                                        <Dropdown
                                            isOpen={info_dropup111}
                                            direction="left"
                                            className="btn-group dropstart"
                                            toggle={() =>
                                                setInfo_dropup111(!info_dropup111)
                                            }
                                        >
                                            <DropdownToggle className="btn btn-info">
                                                <i className="mdi mdi-chevron-left" />{" "}
                                                Dropleft
                                            </DropdownToggle>
                                            <DropdownMenu data-popper-placement="left-start">
                                                <DropdownItem header>
                                                    Header
                                                </DropdownItem>
                                                <DropdownItem disabled>
                                                    Action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown>
                                        <ButtonDropdown
                                            isOpen={infodrp_up1111}
                                            direction="left"
                                            className="btn-group dropstart"
                                            toggle={() =>
                                                setInfodrp_up1111(!infodrp_up1111)
                                            }
                                        >
                                            <DropdownToggle
                                                caret
                                                color="info"
                                                className="dropdown-toggle-split"
                                            >
                                                <i className="mdi mdi-chevron-left" />
                                            </DropdownToggle>
                                            <Button id="caret" color="info">
                                                Split Dropstart
                                            </Button>
                                            <DropdownMenu data-popper-placement="left-start">
                                                <DropdownItem header>
                                                    Header
                                                </DropdownItem>
                                                <DropdownItem disabled>
                                                    Action
                                                </DropdownItem>
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>
                                                    Another Action
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </ButtonDropdown>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
}

export default Dropdowns;